import { createSelector } from 'reselect';
import { scienceProjectsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const scienceProjectsYearsSelector = createSelector([scienceProjectsSelector], (scienceProjects) =>
  extractDatesFromNestedItems(
    [scienceProjects.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
